import Decimal from 'decimal.js-light';
import { SelfServiceAPI } from 'types';
import { CURRENCY_SYMBOLS, CURRENCY_SUFFIX } from 'config/constants';
import { formatNumber } from './formatNumber';

export const formatMoney = ({ amount, currency }: SelfServiceAPI.Total) => {
  const currencyCode = currency.toUpperCase() as SelfServiceAPI.Currency;
  const currencySymbol = CURRENCY_SYMBOLS[currencyCode] || '';
  const currencySuffix = CURRENCY_SUFFIX[currencyCode];
  const decimalAmount = new Decimal(amount);
  const negativeSymbol = decimalAmount.isNegative() ? '-' : '';
  const formatedAmount = formatNumber(decimalAmount.abs(), currencyCode === 'PTS' ? 0 : 2);

  return `${negativeSymbol}${currencySymbol}${formatedAmount} ${currencySuffix}`;
};
